import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { initController } from 'ljit-store-connecter';
import App from './app';
import { initI18n } from '../lib/i18n';
import { getNormalizedLanguage } from '../lib/translate-utils';
import ThemeProvider from '../lib/ui-theme/providers/theme-provider';
import { DEFAULT_THEME_ID } from '../lib/ui-theme/enums';
import {
	createStore,
	StoreProvider,
} from './repositories';
import {
	settingBackground,
	ROOT_BACKGROUND_ID,
} from './lib/root-background';

const store = createStore();

initController(store, connect);

const locale = window.config?.languageCode ||
	navigator.language ||
	navigator.userLanguage;

initI18n(getNormalizedLanguage(locale));

ReactDOM.render(
	<StoreProvider store={store}>
		<BrowserRouter basename="client">
			<div id={ROOT_BACKGROUND_ID}>
				<ThemeProvider rootId={ROOT_BACKGROUND_ID} defaultThemeId={DEFAULT_THEME_ID}>
					<App/>
				</ThemeProvider>
			</div>
		</BrowserRouter>
	</StoreProvider>,
	document.getElementById('client-console-root'),
	() => {
		settingBackground();
	},
);
